// extracted by mini-css-extract-plugin
export default {"balanceWrapper":"MyBalance__balanceWrapper--3X_"};